<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import { keycloak } from "../../main.ts";
import { ProfileAdministrationAPI } from "../../api";

const { t } = useI18n();

const emit = defineEmits(["update"]);
const props = defineProps({
    product: {
        type: String,
        required: true,
    },
    filled: {
        type: Boolean,
        default: false,
    },
    color: {
        type: String,
        default: "var(--p-primary-500)",
    },
    backgroundColor: {
        type: String,
        default: "var(--p-primary-500)",
    },
    size: {
        type: String as () => "small" | "large" | undefined,
        default: "small",
    },
    action: {
        type: String,
        default: "add",
        validator(value) {
            return ["add", "remove"].includes(value as string);
        },
    },
});

async function favoriteProfile() {
    const product = props.product;
    await ProfileAdministrationAPI.favoriteProduct(keycloak.tokenParsed?.sub as string, product as string);

    emit("update", true);
}

const tooltipText = computed(() => {
    return props.action === "add"
        ? t("profile-overview.product-card.tooltips.favorite")
        : t("profile-overview.product-card.tooltips.favoriteRemove");
});
</script>

<template>
    <Badge v-if="filled">
        <Button
            :id="'favorite-button_btn_' + product + '_active'"
            v-tooltip.top="{ value: tooltipText, showDelay: 500 }"
            @click="favoriteProfile()"
            :size="props.size"
            style="min-width: 1.5rem; max-width: 1.5rem; max-height: 1.5rem; line-height: 1.5rem; display: flex"
            text
            rounded
            class="p-0"
            :icon="props.filled ? 'pi pi-heart-fill' : 'pi pi-heart'"
            :pt="{
                root: {
                    style: {
                        background: 'transparent',
                        color: 'white',
                    },
                },
            }"
        />
    </Badge>
    <Badge v-else style="background-color: white; padding: 8">
        <Button
            :id="'favorite-button_btn_' + product + '_in-active'"
            v-tooltip.top="{ value: tooltipText, showDelay: 500 }"
            @click="favoriteProfile()"
            :size="props.size"
            style="min-width: 1.5rem; max-width: 1.5rem; max-height: 1.5rem; line-height: 1.5rem; display: flex"
            text
            rounded
            class="p-0"
            :icon="props.filled ? 'pi pi-heart-fill' : 'pi pi-heart'"
            :pt="{
                root: {
                    style: {
                        background: 'transparent',
                        color: props.color,
                    },
                },
            }"
        />
    </Badge>
</template>
